import {
  IAddon,
  IAppleOrderItem,
  IAppleOrderItemAddonItem,
  IAppleOrderItemProduct,
  IAppleProduct,
  IMenhirAddon,
  IMenhirAppleOrderItem,
  IMenhirAppleOrderItemAddonItem,
  IMenhirAppleOrderItemProduct,
  IMenhirAppleProduct,
} from '@/common/integrations/menhir/employee/marketplace/marketplace.types';

export const transformAddon = (addon: IMenhirAddon): IAddon => ({
  id: addon.id,
  name: addon.name,
  price: addon.price,
  type: addon.type,
});

export const transformAppleProduct = (
  product: IMenhirAppleProduct
): IAppleProduct => ({
  id: product.id,
  reference: product.reference,
  name: product.name,
  description: product.description,
  thumbnail: product.thumbnail,
  addOns: product.add_ons.map(transformAddon),
  price: product.price,
});

export const transformAppleOrderItemAddon = (
  addonItem: IMenhirAppleOrderItemAddonItem
): IAppleOrderItemAddonItem => ({
  quantity: addonItem.quantity,
  total: addonItem.total,
  unitPrice: addonItem.unit_price,
  addOn: {
    id: addonItem.add_on.id,
    name: addonItem.add_on.name,
    type: addonItem.add_on.type,
  },
});

export const transformAppleOrderItemProduct = (
  product: IMenhirAppleOrderItemProduct
): IAppleOrderItemProduct => ({
  id: product.id,
  name: product.name,
  description: product.description,
  reference: product.reference,
  thumbnail: product.thumbnail,
});

export const transformAppleOrderItem = (
  orderItem: IMenhirAppleOrderItem
): IAppleOrderItem => ({
  productItem: {
    product: transformAppleOrderItemProduct(orderItem.product_item.product),
    quantity: orderItem.product_item.quantity,
    total: orderItem.product_item.total,
    unitPrice: orderItem.product_item.unit_price,
  },
  addOnItems: orderItem.add_on_items.map(transformAppleOrderItemAddon),
  total: orderItem.total,
});
